import { useCallback } from "react";
import { useMarkTimelineNotificationsReadMutation } from "web_myplann/Api/NotificationCenter/useMarkTimelineNotificationsReadMutation";
import type { TimelineItemResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import { getNotificationIdsToMarkRead } from "web_myplann/NotificationCenter/Utils/getNotificationIdsToMarkRead";

export const useMarkNotificationAsRead = (): ((
	item: TimelineItemResponseDTO,
) => void) => {
	const { mutate } = useMarkTimelineNotificationsReadMutation();

	return useCallback(
		(item: TimelineItemResponseDTO) => {
			const notificationIds = getNotificationIdsToMarkRead(item);
			if (notificationIds.length === 0) {
				return;
			}
			mutate({ notificationIds });
		},
		[mutate],
	);
};
